<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header>{{ 'tytul.raporty' | translate }}</nb-card-header>  
      <nb-card-body>
        <section >
          <span>{{ 'akcja.wybierz-okres' | translate }}:</span>
        </section>
        <section class="mt-2 ml-3">
          <ngx-zakres-dat (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
        </section>

        <section class="mt-2">
          <button nbButton size="small" (click)="wyswietlanieFiltrow = !wyswietlanieFiltrow">{{ wyswietlanieFiltrow ? ('akcja.ukryj-filtry' | translate) : ('akcja.pokaz-filtry' | translate) }}</button>
        </section>

        <ngx-datatable
          class="bootstrap"
          [rows]="dane"
          [headerHeight]="45"
          [rowHeight]="45"
          [footerHeight]="50"
          [columnMode]="'flex'"
          [messages]="komunikatyTabeli"
          [limit]="15"
        >
          <ngx-datatable-column 
            headerClass="font-weight-bold"
            prop="liczbaPorzadkowa"
            name="{{ 'etykieta.lp' | translate }}"
            cellClass="text-right"
            [flexGrow]="1"
            [summaryFunc]=null
          >
          </ngx-datatable-column>
          <ngx-datatable-column 
            prop="data"
            name="{{ 'etykieta.data' | translate }}"
            cellClass="text-center"
            [flexGrow]="2"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="nazwa"
            name="{{ 'etykieta.nazwa' | translate }}"
            cellClass="text-left"
            [flexGrow]="2"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="typ"
            name="{{ 'etykieta.typ' | translate }}"
            cellClass="text-center"
            [flexGrow]="2"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold"
            prop="url"
            name="{{ 'akcja.pobierz' | translate }}"
            cellClass="text-center"
            [flexGrow]="1"
          >
            <ng-template 
              let-value="value"
              ngx-datatable-cell-template
            >
              <a *ngIf="value" target="_blank" [href]="value">{{ 'akcja.pobierz' | translate }}</a>
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>

        <ng-template #hdrTpl let-column="column" let-sort="sortFn">
          <span class="font-weight-bold" (click)="sort()">{{ column.name }}</span>
          <span [hidden] = "!wyswietlanieFiltrow">
            <br/>
            <input
              nbInput
              fieldSize="small"
              type="search"
              class="w-75"
              (input)="updateFilter($event, column.prop)"
            />
          </span>
        </ng-template>
      </nb-card-body>
    </nb-card>
  </div>
</div>